import {
  OrderOptimizerListItem,
  OrderOptimizerListItemOrders,
  OrderOptimizerListItemRoute,
} from "../../../../../common/services/order-optimizer/list/order-optimizer-list";
import {
  OrderOptimizerCargoListingItemOrder,
  OrderOptimizerCargoListingItemRoute,
  OrderOptimizerCargoListingItem,
} from "./types/order-optimizer-cargo-listing-item";

const createListingItemOrder = (
  order: OrderOptimizerListItemOrders
): OrderOptimizerCargoListingItemOrder => {
  return {
    cargoCompany: order.cargoCompany,
    humanId: order.humanId,
    startTime: order.startTime,
  };
};

const createLIstingItemOrders = (
  orders: OrderOptimizerListItemOrders[]
): OrderOptimizerCargoListingItemOrder[] => {
  return orders.map(createListingItemOrder);
};

const createListingItemRoute = (
  route: OrderOptimizerListItemRoute
): OrderOptimizerCargoListingItemRoute => {
  return {
    lat: route.lat,
    lon: route.lon,
    orderHumanId: route.orderHumanId,
  };
};

const createLIstingItemRoutes = (
  routes: OrderOptimizerListItemRoute[]
): OrderOptimizerCargoListingItemRoute[] => {
  return routes.map(createListingItemRoute);
};

const createListingItem = (
  listItem: OrderOptimizerListItem
): OrderOptimizerCargoListingItem => {
  return {
    id: listItem.id,
    orders: createLIstingItemOrders(listItem.orders),
    reviewedAt: listItem.reviewedAt,
    reviewedBy: listItem.reviewedBy,
    route: createLIstingItemRoutes(listItem.route),
    score: listItem.score,
  };
};

const createListingItems = (
  listItems: OrderOptimizerListItem[]
): OrderOptimizerCargoListingItem[] => {
  return listItems.map(createListingItem);
};

const orderOptimizerCargoListingItemFactory = {
  createListingItems,
};

export default orderOptimizerCargoListingItemFactory;
